import { type BaseCurrencyType } from '@pkg/types';
import { roundToCommonDecimals } from '@pkg/utils';

import { CollectionChainType } from '@app/client/common/structs/daas/v2/common/chains';

export function guessBlockchain(blockchain?: string | null): CollectionChainType {
    const safeBlockchain = blockchain ?? '';
    const formatted = safeBlockchain.toLowerCase();

    if (formatted.includes('apt')) return CollectionChainType.Aptos;
    if (formatted.includes('poly')) return CollectionChainType.Polygon;

    return CollectionChainType.Ethereum;
}

export function nativeCurrencyFromChain(blockchain?: string | CollectionChainType): BaseCurrencyType {
    switch (blockchain) {
        case CollectionChainType.Aptos:
            return 'apt';
        case CollectionChainType.Ethereum:
            return 'eth';
        case CollectionChainType.Polygon:
            return 'matic';
        default:
            return 'usd';
    }
}

export function percentFloat(from = 0, to = 0) {
    const difference = from / to;
    const safeDiff = Number.isFinite(difference) ? difference : 0;
    const result = safeDiff * 100;

    return roundToCommonDecimals(result);
}
